export const CLIENT_ID = '226976688544-hqivfal8p8o0htgu2bklmjkbmshe3vjt.apps.googleusercontent.com'
export const API_KEY = 'AIzaSyDv0iyxzAdVIkS5QJ7CHWD-nGH2Ib64ETI'
export const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest']
export const SCOPE = 'https://www.googleapis.com/auth/calendar.readonly'
export const PAGESIZE = 6
